<template>
  <div class="flex flex-col w-full" v-if="authenticated">
    <div class="flex justify-between mt-10 mx-4 md:hidden">
      <h1 class="uppercase text-blackish tracking-wide text-2xl">
        account
      </h1>
    </div>
    <h1 class="uppercase text-blackish tracking-wide text-2xl mt-10 hidden md:block">
      account
    </h1>
    <div class="mt-10 hidden md:flex">
      <aside class="w-1/4 mr-5 flex flex-col border-r border-b2c-grey-200" >
        <h2 class="text-lg pb-3" :class="fontThin()" v-if="customer">
           {{ $t('profile.greeting') + ' ' + customer.firstname }}
        </h2>
        <ul>
          <li v-if="customer">
            <router-link to="/profile/orders" class="uppercase">
              {{ $t('profile.orders') }}
            </router-link>
          </li>
          <li>
            <router-link to="/profile" class="uppercase">
              {{ $t('profile.data') }}
            </router-link>
          </li>
          <li v-if="customer">
            <router-link to="/profile/addresses" class="uppercase">
              {{ $t('profile.addresses') }}
            </router-link>
          </li>
          <li v-if="customer">
            <router-link to="/profile/coupons" class="uppercase">
              {{ $t('profile.coupons') }}
            </router-link>
          </li>
          <button class="mt-10 uppercase font-bold text-xs" @click="logout">
            {{ $t('profile.logout')}}
          </button>
        </ul>
      </aside>
      <section class="w-3/4">
        <router-view></router-view>
      </section>
    </div>
    <section class="w-11/12 mx-auto md:hidden mt-8">
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  metaInfo() {
    const title = this.$t('titles.profile');
    const description = this.$t('metaDescriptions.account');
    return {
      title,
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  data() {
    return {
      selectedPath: this.$router.currentRoute.path.split('/')[2],
    };
  },

  computed: {
    ...mapGetters({
      customer: ['auth/customer'],
      authenticated: ['auth/authenticated'],
    }),

  },

  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
    }),

    goToPage() {
      this.$router.push({ path: `/profile/${this.selectedPath}` }).catch(() => {});
    },

    async logout() {
      await this.signOut().then(() => {
        this.$router.push('/').catch(() => {});
        this.createNotification('info', `${this.$t('notifications.noMoreLoggedIn')}`);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  li {
    @apply tracking-widest font-bold text-xxs py-2
  }
}

.router-link-exact-active {
  @apply text-gray-600;
}
</style>
